<template>
    <div>
        <div class="title">
            <div class="text mb-0">Rx Request</div>
        </div>
        <loader-list v-if="isLoading" />
        <div v-else-if="isNoConfig">
            Couldn't get PetCare Configurations. Please reload this page or
            contact DaySmart Vet for support.
        </div>
        <div v-else>
            <div class="title">
                <div class="text">Allow Delivery Option</div>
            </div>

            <div class="group-holder">
                Choose which options will be displayed in PetCare. PetCare users
                will be able to see and select the enabled options.
                <div>
                    <div
                        class="green-toggle custom-control custom-switch my-2"
                        v-for="item in deliverOptions"
                        :key="item.code"
                    >
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="item.code"
                            v-model="item.select"
                            :value="item.select"
                            :disabled="item.disabled"
                            @change="updateOption(item.code, item.select)"
                        />
                        <label class="custom-control-label" :for="item.code">
                            {{ item.label }}
                        </label>
                        <div>{{ item.note }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { find } from "lodash";
import LoaderList from "@/components/elements/loader-list";
import SettingPetcare from "@/services/setting/petcare";

const RX_REQUEST = "rx_request";

export default {
    components: {
        LoaderList
    },
    data() {
        return {
            isLoading: false,
            isNoConfig: true,
            deliverOptions: [
                {
                    code: "pickup",
                    label: "Pickup",
                    note:
                        "The 'Pickup' option is always enabled for PetCare users. This option cannot be disabled.",
                    select: true,
                    disabled: true
                },
                {
                    code: "mail",
                    label: "Mail",
                    note:
                        "If the 'Mail' option is turned off, users will only have the 'Pickup' option.",
                    select: false,
                    disabled: false
                }
            ]
        };
    },
    mounted() {
        this.getConfig();
    },
    methods: {
        getConfig() {
            this.isLoading = true;
            this.isNoConfig = false;
            let self = this;

            SettingPetcare.getDeliveryConfig()
                .then(response => {
                    let resource = response.resource;
                    if (
                        response.code === 200 &&
                        resource &&
                        resource.settings
                    ) {
                        let rxrequestSetting = find(
                            resource.settings,
                            function (setting) {
                                return (
                                    setting.type && setting.type === RX_REQUEST
                                );
                            }
                        );

                        //get mail config
                        let selectMail = find(self.deliverOptions, function (
                            option
                        ) {
                            return option.code === "mail";
                        });

                        if (
                            rxrequestSetting &&
                            rxrequestSetting.data &&
                            selectMail
                        ) {
                            selectMail.select =
                                rxrequestSetting.data[0]["mail"];
                        }
                    } else {
                        self._message(
                            "Error : Unable to get PetCare Configurations",
                            "danger"
                        );
                        self.isNoConfig = true;
                    }
                })
                .catch(error => {
                    console.error(error);
                    self._message(
                        "Error : Unable to get PetCare Configurations",
                        "danger"
                    );
                    self.isNoConfig = true;
                })
                .finally(() => {
                    self.isLoading = false;
                });
        },
        updateOption(code, isEnable) {
            let self = this;
            let params = {
                type: RX_REQUEST,
                settings: {}
            };

            if (code === "pickup") {
                return;
            } else {
                params.settings[code] = isEnable;
            }

            SettingPetcare.updateSetting(params)
                .then(response => {
                    if (response.code === 200) {
                        self._message("Successfully update configuration");
                    } else {
                        self._message(
                            "Error : Unable to update PetCare Configurations",
                            "danger"
                        );
                    }
                })
                .catch(error => {
                    self._message(
                        "Error : Unable to update PetCare Configurations",
                        "danger"
                    );
                    console.error(error);
                })
                .finally(() => {
                    self.isLoading = false;
                });
        }
    }
};
</script>
